$(document).ready(function(){
	$(document).on("change","#statut", function(){
		let url = $('.js_filter-interventions').attr('action', this.value)
		console.log(this.value)
	});
});
